export default {"src":"/_next/static/media/bestSeller.a391b6f0.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};